// Live FX rates via Frankfurter (ECB rates, free, CORS enabled, no key)
import { STORAGE_KEYS } from "./constants";

const FX_API = "https://api.frankfurter.dev/v1/latest";
const CACHE_TTL_MS = 1000 * 60 * 60; // 1 hour

const readCache = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.FX_CACHE);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const writeCache = (data) => {
  localStorage.setItem(STORAGE_KEYS.FX_CACHE, JSON.stringify(data));
};

// Fetch all rates relative to base. Returns { base, date, rates: { CODE: rate } }
export async function fetchRates(base = "GBP") {
  const cache = readCache();
  if (
    cache &&
    cache.base === base &&
    Date.now() - cache.fetchedAt < CACHE_TTL_MS
  ) {
    return cache;
  }
  const res = await fetch(`${FX_API}?base=${encodeURIComponent(base)}`);
  if (!res.ok) throw new Error(`FX fetch failed: ${res.status}`);
  const data = await res.json();
  const out = {
    base: data.base,
    date: data.date,
    rates: { ...data.rates, [data.base]: 1 },
    fetchedAt: Date.now(),
  };
  writeCache(out);
  return out;
}

// Convert amount from -> to using a rates object based on `base`.
// rates.rates[X] = how many X per 1 base.
export function convert(amount, from, to, ratesObj) {
  if (!ratesObj || !ratesObj.rates) return amount;
  if (from === to) return amount;
  const base = ratesObj.base;
  const r = ratesObj.rates;
  // base->from: divide by r[from]; then base->to: multiply by r[to]
  const fromRate = from === base ? 1 : r[from];
  const toRate = to === base ? 1 : r[to];
  if (!fromRate || !toRate) return amount;
  const inBase = amount / fromRate;
  return inBase * toRate;
}
